import { render, staticRenderFns } from "./DPaginationTable.vue?vue&type=template&id=31502a0a&scoped=true&"
import script from "./DPaginationTable.vue?vue&type=script&lang=js&"
export * from "./DPaginationTable.vue?vue&type=script&lang=js&"
import style0 from "./DPaginationTable.vue?vue&type=style&index=0&id=31502a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31502a0a",
  null
  
)

export default component.exports